/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fromB64 } from 'src/utils/functiones';

import { DIV } from 'src/components/CustomStyledComponents';
import FooterButton from 'src/components/FooterBtn/FooterButton';
import HeaderPage from 'src/components/header/HeaderPage';
import NavbarHeader from 'src/components/header/NavbarHeader';
import InfoCompra from 'src/components/InfoCompra';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import useLoading from 'src/hooks/useLoading';
import { guardarLead, POST } from 'src/services';
import { urlGenerarOtraCotizacion } from 'src/services/urls';
import useCotizacion from 'src/hooks/useCotizacion';
import './styles.css';


// const FinProcesoInfo = ({ cotizacion, idCotizacion }) => {
const FinProcesoInfo = () => {

  const { cotizacion, idCotizacion } = useCotizacion()

  const { result = "" } = useParams<any>();
  const { values, setLoading, resetLoading, setSecundario } = useLoading();

  const [pageProps, setPageProps] = useState({
    header: {
      titulo: <h4 className="titulo font-weight-bold">Compra no completada</h4>,
      descripcion: <p className="descripcion"> Cotizacion </p>,
    },
  });

  console.log("result", result)
  useEffect(() => {

    if (result) {
      setPageProps({ ...pageProps, header: { ...pageProps.header, descripcion: <p className="descripcion"> Cotizacion {fromB64(result)} </p>, } })
    }
  }, [result])

  const onClickGoHome = async () => {
    if (!!cotizacion?.producto?.urlRetorno) {
      window.location.href = cotizacion?.producto?.urlRetorno
      return;
    }
    setLoading(true);
    setSecundario('Espere por favor...');
    const body = {
      idCotizacion,
    };

    guardarLead(idCotizacion, `FIN_COTIZACION`);
    const res = await POST(urlGenerarOtraCotizacion, body);

    if (res.transaccion) {
      window.location.href = res.data.url;
    }
  };


  if ((!cotizacion || !idCotizacion) && !values.loading)
    return null;

  // console.log(values)
  const flujo = cotizacion?.flujoPlugin
  return (
    <LoadingWrapper {...values}>
      <DIV stylePath="finCompra.globalStyles" className="container-fluid container-page">
        <NavbarHeader showBack={false} />
        <HeaderPage progreso={100} />

        <div className="row justify-content-center">
          {pageProps.header && (
            <div className="col-11 col-md-6 mt-3">
              {pageProps?.header?.titulo}
              {pageProps?.header?.descripcion}
            </div>
          )}
        </div>

        <div className="row justify-content-center">
          <InfoCompra
            total={cotizacion.valoresPagar.total}
            periocidadPago={'Pago' + cotizacion.producto.periocidadPago}
          />
          <div className="col-10 col-sm-8 text-center">
            <h6 style={{ fontSize: '14px' }}> {`${cotizacion?.titular?.nombre1} ${cotizacion?.titular?.apellido1}`}</h6>
            <p>Gracias por preferirnos</p>
          </div>
        </div>

        {/* <FooterButton label="Ir al inicio" onClick={onClickGoHome} /> */}
        {(flujo === '1' || flujo === '24' || !!cotizacion?.producto?.urlRetorno || cotizacion?.producto?.tieneInicioSesion === '1') && (
          <FooterButton label="Ir al inicio" onClick={onClickGoHome} />
        )}
      </DIV>
    </LoadingWrapper>
  );

};

export default FinProcesoInfo;


